
import { DropDownOptions } from "devextreme-react/drop-down-box";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef,  useCallback,  useEffect,  useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { DropDownGrid } from "../../../../../components";
import { getApiParams } from "../../../../../redux/auth";
import { BodyType, createRequest } from "../../../../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../../../../redux/base/types/saga";
import { getLocalized } from "../../../../../redux/localization";
import { SendAccountCallLog } from "../../../../call-logs/type";
import { AccountCallLogStatus } from "../../../../callStatus/type";



export const CreateAccountCallLogForm = forwardRef<any, { data: SendAccountCallLog }>((
    { data}, ref
) => {
    const [, setId] = useState();
    const localize = useSelector(getLocalized);
    const { Id }: { Id: string } = useParams();
    const [callLogStatusTypes, setCallLogStatusTypes] = useState<AccountCallLogStatus[]>([]);
    data.AccountId = Id
    const { token, lang } = useSelector(getApiParams);

    const getCallStatusTypes = useCallback((async () => {
        const response: ApiResponse<AccountCallLogStatus[]> = await createRequest({
            method: "GET",
            url: "/api/admin/adminaccountcalllogstatuses",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCallLogStatusTypes(response.Result)
        }
    }), [token, lang])

    useEffect(()=> {
        getCallStatusTypes()
    },[getCallStatusTypes])
    return <Form
        formData={data}
        ref={ref}

    >
        <GroupItem>
            <SimpleItem
                dataField={"TalkedWith"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("talkedWidth")
                }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"AccountCallLogStatusId"}
                editorType={"dxLookup"}

                render={(item: any) => (
                    <DropDownGrid
                        dataSource={callLogStatusTypes}
                        columns={["Name"]}
                        displayExpr="Name"
                        returnSelectedId={async (id: any) => {
                            console.log(id)
                            item.editorOptions.value = id;
                            data.AccountCallLogStatusId = id
                            setId(id);
                        }}
                        value={data.AccountCallLogStatusId}
                        dropDownOptions={{ width: 500 }} />
                )}
                label={{
                    text: localize.getString("callStatus")
                }}
            >
                <DropDownOptions closeOnOutsideClick showTitle={false} />
            </SimpleItem>
            <SimpleItem
                dataField={"Note"}
                editorType={"dxTextArea"}
                label={{
                    text: localize.getString("note")
                }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"NextCallDate"}
                editorType="dxDateBox"
                editorOptions={{
                    dateSerializationFormat: "yyyy-MM-dd"
                }}
                label={{
                    text: localize.getString("nextCallDate")
                }}

            >

            </SimpleItem>
            <SimpleItem
                dataField={"NextCallNote"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("nextCallNote")
                }}
            >

            </SimpleItem>

        </GroupItem>
    </Form >
})